module.exports = __webpack_public_path__ + "static/img/casino-pc-thum04.a21a9a7.png";